import { BankCardContainer } from '../BankCardContainer';
import styles from './BankCard.module.scss';

type BankCardProps = {
  bankName: string;
  fio: string;
  imgSrc: string;
};

export const BankCard = ({ bankName, fio, imgSrc }: BankCardProps) => {
  return (
    <BankCardContainer className={styles.infoBlockContainer}>
      {imgSrc && <img src={imgSrc} alt={bankName} className={styles.img} />}
      <div className={styles.infoBlockInner}>
        <h4 className={styles.bankName}>{bankName}</h4>
        {fio && <p className={styles.fio}>{fio}</p>}
      </div>
    </BankCardContainer>
  );
};
